export default __webpack_public_path__ + "2260c51999fec6afb3673ab456bfd013.png";